module.exports = __webpack_public_path__ + "img/pet.4d8ec82f.png";